import { SectionOne, SectionThree, SectionTwo, } from "../components/feature/contact";

export default function Contact()
{
    return(
        <section className="">
            <SectionOne/>
            <SectionTwo/>
            <SectionThree/>
        </section>
    );
}